import { Link } from "react-router-dom";
import plymhairLogo from "@/assets/plymhair-logo.svg";
import catWigs from "@/assets/cat-wigs.webp";
import catExtensions from "@/assets/cat-extensions.webp";
import catHairpieces from "@/assets/cat-hairpieces.webp";
import catHeadwear from "@/assets/cat-headwear.webp";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { cn } from "@/lib/utils";

const collections = [
  { title: "Human Hair Wigs", image: catWigs, category: "Human Hair Wigs" },
  { title: "Extensions", image: catExtensions, category: "Extensions" },
  { title: "Hair Pieces", image: catHairpieces, category: "Hair Pieces" },
  { title: "Head Wear", image: catHeadwear, category: "Head Wear" },
];

const CollectionsGrid = () => {
  const { ref, visible } = useScrollReveal();

  return (
    <section
      ref={ref}
      className={cn(
        "py-20 bg-background transition-all duration-700 ease-out",
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
      )}
    >
      <div className="container">
        <div className={cn("text-center mb-12 transition-all duration-700 delay-100 ease-out", visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6")}>
          <h2 className="font-display text-3xl md:text-4xl font-bold mb-3">Latest Collections</h2>
          <p className="text-muted-foreground font-body">
            Find the perfect match to add fullness, length and bounce
          </p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 max-w-5xl mx-auto">
          {collections.map((col, i) => (
            <Link
              key={col.title}
              to={`/shop?category=${encodeURIComponent(col.category)}`}
              className={cn(
                "group product-card-hover relative aspect-[4/5] overflow-hidden rounded transition-all duration-500 ease-out",
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              )}
              style={{ transitionDelay: visible ? `${200 + i * 100}ms` : "0ms" }}
            >
              <img
                src={col.image}
                alt={`${col.title} collection – premium hair products at Plymhair`}
                loading="lazy"
                width={640}
                height={800}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground/70 via-foreground/20 to-transparent" />
              <div className="absolute top-2.5 left-2.5 w-8 h-8 rounded-full bg-background/80 backdrop-blur-sm flex items-center justify-center shadow-sm">
                <img src={plymhairLogo} alt="Plymhair and Extensions boutique logo" className="w-5 h-5 object-contain" />
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-5">
                <h3 className="font-display text-xl sm:text-lg md:text-xl font-bold text-primary-foreground uppercase leading-tight mb-2">
                  {col.title}
                </h3>
                <span className="inline-block bg-primary text-primary-foreground font-body text-[10px] sm:text-xs font-semibold tracking-widest uppercase px-4 sm:px-5 py-1.5 sm:py-2 opacity-100 sm:opacity-0 sm:group-hover:opacity-100 transition-opacity duration-300">
                  View All
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CollectionsGrid;
